module.exports = __webpack_public_path__ + "media/images/landkit/screenshots/landkit/pages/blog-showcase-81fba0f047aab14624bc8423f2c05aca.jpg";